export default __webpack_public_path__ + "static/media/_IMG4140.0810f156.jpg";